module.exports = __webpack_public_path__ + "static/media/propic-3.f729e842.png";